import { Button, Col, Row, Card, Statistic, Spin } from "antd";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { AdminMenuLayout } from "../../../shared/components";
import { useCashbackReport } from "../hooks";
import { CashbackReportFilters } from "./CashbackReportFilters";
import { CashbackReportTable } from "./CashbackReportTable";
import { CashbackReportSummary } from "./CashbackReportSummary";
import { WrapperCardCashbackReport } from "./styled";

export const CashbackReport = () => {
  const {
    loading,
    reportData,
    filters,
    updateFilters,
    clearFilters,
    exportToExcel,
    fetchReport,
  } = useCashbackReport();

  return (
    <AdminMenuLayout
      pageDescription="Reporte detallado de cashback entregado por productos, marcas y categorías"
      title="Reporte de Cashback"
    >
      <WrapperCardCashbackReport>
        <Row gutter={[16, 16]} style={{ padding: "16px" }}>
          <Col span={24}>
            <Card title="Filtros" size="small">
              <CashbackReportFilters
                filters={filters}
                onFiltersChange={updateFilters}
                onClearFilters={clearFilters}
              />
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ padding: "0 16px 16px" }}>
          <Col span={24}>
            <Card
              title="Resumen"
              size="small"
              extra={
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={() => fetchReport()}
                    loading={loading}
                  >
                    Actualizar
                  </Button>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={exportToExcel}
                    disabled={!reportData?.data?.length}
                  >
                    Exportar
                  </Button>
                </div>
              }
            >
              <CashbackReportSummary summary={reportData?.summary} />
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ padding: "0 16px 16px" }}>
          <Col span={24}>
            <Card title="Detalle de Transacciones" size="small">
              <Spin spinning={loading}>
                <CashbackReportTable data={reportData?.data || []} />
              </Spin>
            </Card>
          </Col>
        </Row>
      </WrapperCardCashbackReport>
    </AdminMenuLayout>
  );
};
